import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Pricing from "./components/Pricing";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickyCallButton from "./components/StickyCallButton";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";
import { suppressResizeObserverErrors } from "./utils/suppressErrors";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import BookingSuccess from "./pages/BookingSuccess";
import AdminDashboard from "./pages/AdminDashboard";
import MyBookings from "./pages/MyBookings";
import AuthCallback from "./pages/AuthCallback";

// Router wrapper to handle auth callback before routes
function AppRouter() {
  const location = useLocation();

  // Check URL fragment (not query params) for session_id - synchronous check
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={
        <div className="App">
          <Header />
          <Hero />
          <Pricing />
          <Services />
          <WhyChooseUs />
          <Contact />
          <Footer />
          <StickyCallButton />
          <Toaster />
        </div>
      } />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/booking-success" element={<BookingSuccess />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/my-bookings" element={<MyBookings />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    // Initialize comprehensive error suppression
    const cleanup = suppressResizeObserverErrors();
    
    return cleanup;
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
